import { Flex, Spin, theme, Typography } from 'antd';

const { Text } = Typography;

/** Muestra un spinner centrado con un mensaje de carga. */
export const LoadingIndicator = ({ message = 'Cargando...' }) => {
  const { token: themeToken } = theme.useToken();

  return (
    <Flex justify='center' align='center' gap='small' vertical style={{ height: '100%' }}>
      <Spin />
      <Text style={{ color: themeToken.colorPrimary }}>
        {message}
      </Text>
    </Flex>
  );
};
